import React, { useState, useEffect } from "react";
import { Table, Icon, Input } from "semantic-ui-react";
import { map } from "lodash";
import { Button } from "semantic-ui-react";

export function TableGruposR(props) {
  const { grupos, gestionarGrupo } = props;
  const itemsPerPage = 25;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [realTimeSearch, setRealTimeSearch] = useState("");

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
  }, [searchText]);

  const handleRealTimeSearchChange = (value) => {
    setRealTimeSearch(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    setSearchText(realTimeSearch.toLowerCase());
  }, [realTimeSearch]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredGrupo = grupos.filter((grupoo) =>
    String(grupoo.numero_grupo).includes(realTimeSearch)
  );

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
    if (searchText === "") {
      setCurrentPage(1);
    }
  }, [searchText, setCurrentPage]);

  useEffect(() => {
    const lastPage = Math.ceil(filteredGrupo.length / itemsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  }, [filteredGrupo, currentPage, setCurrentPage]);

  const sortedGrupos = filteredGrupo.sort((a, b) => {
    const numeroGrupoA = parseInt(a.numero_grupo);
    const numeroGrupoB = parseInt(b.numero_grupo);
    return numeroGrupoA - numeroGrupoB;
  });

  const paginatedGrupos = sortedGrupos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  return (
    <div>
      <div>
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por grupo"
          value={realTimeSearch}
          onChange={(e) => handleRealTimeSearchChange(e.target.value)}
          style={{ marginTop: "12px" }}
        />
      </div>
      <Table className="table-users-admin">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>GRUPO</Table.HeaderCell>
            <Table.HeaderCell>ALUMNOS</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {map(paginatedGrupos, (grupoo, index) => (
            <Table.Row key={index + 1}>
              <Table.Cell>{grupoo.numero_grupo}</Table.Cell>
              <Table.Cell>{grupoo.alumnos.length}</Table.Cell>
              <Actions grupo={grupoo} gestionarGrupo={gestionarGrupo} />
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group>
          {Array.from({
            length: Math.ceil(grupos.length / itemsPerPage),
          }).map((_, index) => {
            const pageNumber = index + 1;
            const maxVisibleButtons = 4;
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisibleButtons / 2)
            );
            const endPage = Math.min(
              startPage + maxVisibleButtons - 1,
              Math.ceil(grupos.length / itemsPerPage)
            );
            const showStartEllipsis = startPage > 1;
            const showEndEllipsis =
              endPage < Math.ceil(grupos.length / itemsPerPage);

            if (Math.ceil(grupos.length / itemsPerPage) === 1) {
              return null;
            }
            if (pageNumber >= startPage && pageNumber <= endPage) {
              return (
                <Button
                  key={pageNumber}
                  icon
                  active={currentPage === pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Button>
              );
            } else if (showStartEllipsis && pageNumber === 1) {
              return (
                <Button key="startEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            } else if (
              showEndEllipsis &&
              pageNumber === Math.ceil(grupos.length / itemsPerPage)
            ) {
              return (
                <Button key="endEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            }
            return null;
          })}
        </Button.Group>
      </div>
    </div>
  );
}
function Actions(props) {
  const { grupo, gestionarGrupo } = props;
  return (
    <Table.Cell textAlign="center">
      <div className="action-buttons">
        <Button
          icon
          onClick={() => {
            gestionarGrupo(grupo);
          }}
          className="botonEnviar"
        >
          Gestionar grupo
        </Button>
      </div>
    </Table.Cell>
  );
}
